export type LauncherPosition = { x: number; y: number }
export type LauncherPreference = { version: 1; side: 'left' | 'right'; yRatio: number }
export type LauncherViewport = { left: number; top: number; width: number; height: number }
export type LauncherInsets = { left: number; top: number; right: number; bottom: number }
export type LauncherBounds = { left: number; top: number; right: number; bottom: number }

const MARGIN = 12
const clamp = (value: number, min: number, max: number) => Math.min(max, Math.max(min, value))

export function launcherBounds(
  viewport: LauncherViewport,
  size: { width: number; height: number },
  insets: LauncherInsets,
): LauncherBounds {
  const left = viewport.left + insets.left + MARGIN
  const top = viewport.top + insets.top + MARGIN
  return {
    left,
    top,
    right: Math.max(left, viewport.left + viewport.width - insets.right - MARGIN - size.width),
    bottom: Math.max(top, viewport.top + viewport.height - insets.bottom - MARGIN - size.height),
  }
}

export function clampLauncher(
  position: LauncherPosition,
  bounds: LauncherBounds,
): LauncherPosition {
  return {
    x: clamp(position.x, bounds.left, bounds.right),
    y: clamp(position.y, bounds.top, bounds.bottom),
  }
}

export function snapLauncher(
  position: LauncherPosition,
  bounds: LauncherBounds,
): LauncherPreference {
  const point = clampLauncher(position, bounds)
  return {
    version: 1,
    side: point.x - bounds.left < bounds.right - point.x ? 'left' : 'right',
    yRatio:
      bounds.bottom === bounds.top ? 0 : (point.y - bounds.top) / (bounds.bottom - bounds.top),
  }
}

export function restoreLauncher(
  preference: LauncherPreference,
  bounds: LauncherBounds,
): LauncherPosition {
  return {
    x: bounds[preference.side],
    y: bounds.top + clamp(preference.yRatio, 0, 1) * (bounds.bottom - bounds.top),
  }
}
